import Field from './Field'

export default function FieldTableSelect (label, key, items, rules, options, on) {
  Field.call(this, label, key, rules, options, on)
  this.type = 'tableSelect'
  this.items = items
}


// WEBPACK FOOTER //
// ./packages/helper/fields/FieldTableSelect.js